"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectQuickSuggestionOption')(function selectQuickSuggestionOption(option, choice, state) {
    var optionState = state.optionState;
    optionState[option] = choice;
}));
//# sourceMappingURL=selectQuickSuggestionOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-quick-suggestions-option/lib/actions/selectQuickSuggestionOption.js
// module id = 5133
// module chunks = 2